import moment from 'moment';
import { mapActions, mapGetters } from 'vuex';
import sRouter from '@/services/sRouter';
import sPackage from '@/services/sPackage';
import { getMenuScheme, visibilityDependOnAcl } from '@/components/Panel/MenuCommon';


// COMPONENT ///////////////////////////////////////////////////////////////////
export default {
  name: 'PackageUsage',

  props: {
  },

  data() {
    return {
      icons: {
        pieChart: require("@/assets/pie-chart.svg"),
        arrow: require("@/assets/arrow-up.svg"),
      },

    }
  },
  computed: {
    ...mapGetters(['servicesList']),
    processedPackages() {
      let list = this.servicesList.filter(item => 
        item.consumable && item.checkable && item.active
      );
      for (let i = 0; i < list.length; i += 1) {
        list[i].packageBarWidth = list[i].max_amount ? Math.min(100, list[i].amount * 100 / list[i].max_amount) : !!list[i].amount;
      }
      return list;
    },
  },
  created() {
    this.gb2str = sPackage.gb2str;
    this.usageVisible = false;
    this.getServicesList();
  },
  methods: {
    ...mapActions(['getServicesList', 'getPackageUsage', 'clearPackageUsage', 'selectCategory']),
    showUsage(newValue) {
      this.usageVisible = newValue;
      this.$forceUpdate();
    },
    changeUrl(category) {
      sRouter.changeUrl({ name: 'Services' }, this.$router);
      if (category === 'Pakiety') category = 'Internet krajowy';
      this.selectCategory(category);
    }
  },
};



// WEBPACK FOOTER //
// ./src/components/MyAccount/PackageUsage/component.js